import API from "../api/axios";

// ─── Get Daily Visits ───
export const getDailyVisits = async (filters = {}) => {
   const res = await API.get("/daily-visits", {
      params: filters
   });
   return res.data;
};

// ─── Create Daily Visit ───
export const createDailyVisit = async (data) => {
   const res = await API.post("/daily-visits", data);
   return res.data;
};

// ─── Update Daily Visit ───
export const updateDailyVisit = async (id, data) => {
   const res = await API.put(`/daily-visits/${id}`, data);
   return res.data;
};

// ─── Delete Daily Visit ───
export const deleteDailyVisit = async (id) => {
   const res = await API.delete(`/daily-visits/${id}`);
   return res.data;
};

// ─── Export Daily Visits ───
export const exportDailyVisits = async () => {
   try {
      const res = await API.get("/daily-visits/export", {
         responseType: "blob"
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = "Daily_Visits.xlsx";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

   } catch (err) {
      let errorMessage = "Export failed";

      if (err.response?.data instanceof Blob) {
         try {
            const text = await err.response.data.text();
            const data = JSON.parse(text);
            errorMessage = data.message || errorMessage;
         } catch { }
      } else {
         errorMessage = err.response?.data?.message || errorMessage;
      }

      throw new Error(errorMessage);
   }
};

// ─── Get Daily Visit Stats ───
export const getDailyVisitStats = async () => {
   const res = await API.get("/daily-visits/stats");
   return res.data;
};

// ─── Get Recent Visits ───
export const getRecentVisits = async () => {
   const res = await API.get("/dashboard/recent-visits");
   return res.data;
};

// ─── Get Visit Trend ───
export const getVisitTrend = async (range) => {
   const res = await API.get("/dashboard/visit-trend", {
      params: { range }
   });
   return res.data;
};